export class DeviceBusyNotification
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);

            if (json.UntilWhen) this.UntilWhen = new Date(json.UntilWhen);
        }
    }

    DeviceId: number;
    DeviceUId: string;
    ReasonCode: number;
    ReasonMessage: string;
    TypeCode: number;
    UntilWhen: Date;
}
